import { right } from "@popperjs/core";

export const IT = {
  feature: {
    auth: {
      login: "Accedi",
      $login: {
        title: "Accedi al tuo account!",
      },
      forgot_password: "Password dimenticata",
      $forgot_password: {
        title: "Password dimenticata?",
        message:
          "Inserisci il tuo indirizzo email qui sotto e invieremo un codice all'email fornita per reimpostare la tua password",
      },
      reset_password: "Reimposta password",
      $reset_password: {
        message:
          "Abbiamo inviato il codice di conferma a <b>{email}</b>. Inserisci la tua nuova password e confermala di nuovo nel campo sottostante",
        expires_in: "Il codice di conferma scadrà tra <b>{time}</b> secondi",
        code_expired: "Codice scaduto",
        code_expired_message:
          "Il tuo codice di conferma è scaduto. Invia nuovamente una richiesta, per favore",
      },
      $update_password: {
        success_message: "La tua password è stata aggiornata con successo",
        force_message: "La tua password è scaduta. Aggiorna la tua password",
        first_access: "Questo è il tuo primo accesso. Aggiorna la tua password",
      },
      $recovery_user_password: {
        title: "Recupero password",
        success_message:
          "La procedura di recupero della password è stata completata con successo.\nL'utente riceverà un'email con le istruzioni per reimpostare la password.",
        error_message:
          "La procedura di recupero della password non è andata a buon fine.\nPer favore riprova.",
        message:
          "Invia a questo utente un'email con le istruzioni per reimpostare la sua password.",
      },
      request_support: "Richiedi supporto",
      $request_support: {
        message: "Compila il modulo per richiedere supporto",
        request_type: "Tipo di richiesta",
        $request_type: {
          1: "Non riesco ad accedere",
          2: "L'app non funziona correttamente",
          3: "Ho una domanda su una funzionalità",
        },
        success_message:
          "La richiesta di supporto è stata inviata con successo.\nRiceverai una risposta al più presto.",
      },
      invitation: "Invito",
      $invitation: {
        instructions: "Inserisci l’indirizzo email del nuovo utente e invia il modulo. Il sistema invierà un’email con le istruzioni per completare la registrazione. L’invito sarà valido per 48 ore dal momento dell’invio.",
        send_success_message:
          "L'invito è stato inviato con successo.\nL'utente riceverà un'email con le istruzioni per accettare l'invito.",
        accept_success_message:
          "L'invito è stato accettato con successo.\nRiceverai un'email con le tue credenziali.",
        pending_invitations: "Inviti in sospeso",
        pending_invitations_message: "La tabella elenca tutti gli inviti in sospeso. Una volta che il link dell’invito sarà scaduto, verrà visualizzato un pulsante per inviare un nuovo invito.",
        resend_invitation: "Invia nuovamente l’invito",
        invitation_expires_date: "Data di scadenza dell’invito",
        email_address: "Indirizzo email",
      },
      delete_account: "Elimina account",
      $delete_account: {
        disclaimer:
          "La cancellazione dell'account è un'operazione permanente. Procedendo, tutti i tuoi dati verranno eliminati e non potranno essere recuperati. Assicurati di aver salvato tutte le informazioni necessarie prima di proseguire.",
        alert_message:
          "Attenzione: questa operazione rimuoverà definitivamente il tuo account e tutti i dati associati. Se non sei sicuro, ti invitiamo a contattare il supporto prima di confermare.",
        success_message:
          "Il tuo account è stato eliminato con successo. Tutti i dati sono stati rimossi in modo permanente. Grazie per aver utilizzato il nostro servizio.",
        process_pending_warning: "<strong>Attenzione: il paziente {patient_full_name} ha esercitato il diritto alla revoca del consenso o alla cancellazione del proprio account.</strong><br>Ti invitiamo a scaricare i dati del paziente utilizzando la funzione di esportazione disponibile nella sua scheda. Trascorso il periodo di tolleranza previsto, i dati saranno rimossi in modo permanente e non saranno più accessibili."
      },
      $withdraw_consent: {
        alert_message:
          "Revocando il consenso, non potremo più trattare i tuoi dati personali per le finalità precedentemente autorizzate. Alcuni servizi potrebbero non essere più disponibili.",
        success_message:
          "Il consenso al trattamento dei dati è stato revocato con successo. Puoi modificare le tue preferenze in qualsiasi momento dal tuo profilo.",
      },
      $download_patient_data: {
        success_message:
          "I dati del paziente sono stati generati correttamente e sono pronti per il download. Ti invitiamo a conservarli in un luogo sicuro e a rispettare la normativa sulla privacy.",
      },
      $otp_login: {}
    },
    therapy: {
      name: "Terapia",
      active_therapies: "Terapie attive | Terapia attiva | Terapie attive",
      inactive_therapies:
        "Terapie inattive | Terapia inattiva | Terapie inattive",
      prescription: "Prescrizione",
      intake: {
        $status: {
          0: "In attesa",
          1: "Assunta",
          2: "Assunta fuori tempo",
          3: "Non assunta",
        },
        taken: "Assunta",
        taken_in_time: "Assunta in tempo",
        taken_not_in_time: "Assunta fuori tempo",
        not_taken: "Non assunta",
        expected: "Prevista",
        total: "Totale",
        subtotal: "Subtotale",
      },
      $trend_range: {
        day: "Giorno",
        week: "Settimana",
        month: "Mese",
        year: "Anno",
        $frequency: {
          day: "Giornaliero",
          week: "Settimanale",
          month: "Mensile",
          year: "Annuale",
        },
      },
      $range: {
        from: "Da",
        to: "A",
      },
      no_data: "Nessun dato raccolto",
      no_therapy_scheduled_today: "Nessuna terapia programmata per oggi",
      no_therapy_scheduled: "Nessuna terapia programmata",
      provide_therapy: "Aggiungi nuova terapia",
      drug: "Farmaco",
      prn: "PRN",
      dose: "Dose",
      overall_adherence: "Aderenza complessiva",
      adherence: "Aderenza",
      intakes_per_day:
        "{count} volte al giorno | {count} volta al giorno | {count} volte al giorno",
      add_all_prn: "Aggiungi tutti i PRN",
      show_prn: "Visualizza PRN",
      daily_calendar: "Calendario giornaliero",
    },
    home: {
      welcome_message: "Buongiorno, {name}!",
      welcome_subtitle: "Benvenuto nel portale HCP",
      your_center: "Il tuo Centro",
      $stats: {
        center: "Statistiche del Centro",
        total_patients: "Pazienti totali",
        total_caregivers: "Caregiver totali",
        total_hcps: "HCP totali",
        centers_count: "Centri totali",
        countries_count: "Paesi coinvolti",
        patients_invited_count: "Pazienti invitati",
        cargivers_count: "Caregiver totali",
        patients_activated_count: "Pazienti attivati",
        therapies_started_count: "Terapie in corso",
      },
    },
    lists: {
      result_total: "Mostrando <b>{count}</b>",
      result_counts: "Mostrando <b>{count}</b> di <b>{total}</b>",
      result_count_range:
        "Mostrando <b>{start}</b> - <b>{end}</b> di <b>{total}</b>",
      out_of: "di",
    },
    surveys: {
      patient_surveys: "Questionari",
      history: "Storico",
      no_surveys: "Nessun questionario inviato",
      treshold: "Soglia consigliata",
      set_priority: "Imposta priorità",
      modal_message:
        "Una volta impostata, non potrai disattivarla fino alla scadenza.",
      typology: {
        table: "Tabella",
        list: "Lista",
      },
      not_available_answer: "N/D",
      PDI: {
        right_eye: "Occhio destro",
        left_eye: "Occhio sinistro",
      },
      frequency: "Frequenza",
      $frequency: {
        D: "Giornaliera",
        M: "Mensile",
        Y: "Annuale",
        O: "Una volta",
      },
      value_representation_type: "Tipo di rappresentazione del valore",
      $value_representation_type: {
        integer: "Intero",
        percentage: "Percentuale",
        other: "Altro",
      },
      min_value: "Valore minimo",
      max_value: "Valore massimo",
      min_label: "Etichetta valore minimo",
      max_label: "Etichetta valore massimo",
      step_increment: "Incremento graduale",
      key_recommendations:
        "Fornisci una chiave univoca per identificare il Questionario (es. questionario_preliminare)",
      is_notifiable: "Invia notifiche",
      default_frequency_days: "Frequenza notifiche in giorni",
      default_notification_time: "Orario notifica",
      extra: "Extra (formato JSON)",
      $steps: {
        key_recommendations:
          "Fornisci una chiave univoca per identificare il Passo (es. dolore_oggi)",
        add: "Aggiungi Passo",
        save: "Salva Passo",
        delete: "Elimina Passo",
        discard_changes: "Annulla modifiche",
        type: "Tipo",
        $type: {
          R: "Radio",
          T: "Testo",
          V: "Valore",
          D: "Descrizione",
          F: "Finalizza",
          VSS: "Sentimento",
          VAS: "Scala analogica visiva",
          PDI: "Punti di interesse",
          TS: "Intervallo di tempo",
        },
        raw: "Grezzo",
        editor: "Editor",
        drag_reorder:
          "Trascina e rilascia l’indice per modificare l’ordine dei passi",
      },
      display_in_chart: "Mostra nel grafico",
      chart_type: "Tipo di grafico",
      $chart_type: {
        line: "Linea",
        bar: "Barra",
        body_map: "Mappa corporea",
      },
      labels: {
        bar_y_label: "Numero di risposte date",
      },
      required: "Obbligatorio",
      include_na_option: "Includi opzione /N.D.",
      conditions: "Condizioni",
      role: "Ruolo",
    },
    roles: {
      type: "Tipo",
      $type: {
        A: "Amministratore",
        H: "HCP",
        C: "Caregiver",
        P: "Paziente",
        I: "Interno",
      },
      roles_permissions: "Permessi dei ruoli",
      centers_permissions: "Permessi dei centri",
      $permissions: {
        index: "Indice",
        show: "Visualizza",
        store: "Salva",
        update: "Aggiorna",
        destroy: "Elimina",
      },
      center_users_management: "Gestione utenti",
      zone: "Zona",
      remind_policies: {
        title: "Reminder policies",
        message:
          "Per favore ricorda di impostare le policy per il nuovo ruolo creato ({type}) per garantire un accesso e una conformità adeguati.",
      },
      journey_schemas: "Journey Schemas",
      remind_journey_schemas: {
        title: "Promemoria Journey Schemas",
        message: "Assegna Journey Schema a questo ruolo per definire l'esperienza del paziente in base al loro ruolo.",
      },
    },
    contents: {
      $categories: {
        visible: "Visibile",
        visibility: "Visibilità",
        $visibility: {
          all: "Pubblico",
          restricted: "Riservato",
          undefined: "",
        },
        visibility_checkbox_message:
          "Le categorie pubbliche saranno visibili a tutti i pazienti",
        imageCover: "Copertina",
      },
      blocks: "Blocchi",
      $blocks: {
        add: "Aggiungi Blocco",
        save: "Salva Blocco",
        delete: "Elimina Blocco",
        discard_changes: "Annulla modifiche",
        type: "Tipo",
        $type: {
          text: "Testo",
          image: "Immagine",
          video: "Video",
          html: "HTML",
        },
        raw: "Grezzo",
        editor: "Editor",
        drag_reorder:
          "Trascina e rilascia l’indice per modificare l’ordine dei blocchi",
      },
      content_permissions: "Contenuti del paziente",
      category: "Categoria",
      lang: "Lingua",
      $lang: {
        en: "Inglese",
        it: "Italiano",
        de: "Tedesco",
        fr: "Francese",
        es: "Spagnolo",
      },
    },
    consents: "Consensi",
    $consents: {
      enabled_consents: "Consensi associati",
      hcp_enabled_consents: "Consensi associati agli HCPs",
      role_enabled_consents: "Consensi associati al ruolo {role}",
      update: "Abbiamo aggiornato la nostra informativa sulla privacy.",
      update_message: "Ti invitiamo a prenderne visione e ad accettarla per continuare a utilizzare l’app.",
    },
    consent: {
      draft: "Bozza",
      version_history: "Cronologia versioni",
    },
    messages: "Messaggi",
    $messages: {
      send: "Invia messaggio",
      select_patient_message: "Seleziona un paziente per inviare messaggi",
    },
    $events: {
      all_day: "Tutto il giorno",
    },
    $caregivers: {
      no_caregivers: "Nessun caregiver assegnato a questo paziente",
    },
    $extra_fields: {
      no_choices: "Nessuna opzione selezionata",
    },
  },
  page: {
    home: "Home",
    patients: "Pazienti",
    patient: "Paziente",
    caregivers: "Caregiver",
    add_caregiver: "Aggiungi Caregiver",
    edit_caregiver: "Modifica Caregiver",
    analytics: "Statistiche",
    create_patient: "Crea Nuovo Paziente",
    edit_patient: "Modifica Paziente",
    system_users: "Utenti di Sistema",
    invite_user: "Invita Utente",
    create_user: "Crea Utente",
    edit_user: "Modifica Utente",
    users: "Utenti",
    user: "Utente",
    centers: "Centri di Sistema",
    create_center: "Crea Centro",
    edit_center: "Modifica Centro",
    center: "Centro",
    profile: "Profilo",
    update_password: "Aggiorna password",
    roles: "Ruoli di Sistema",
    create_role: "Crea Ruolo",
    edit_role: "Modifica Ruolo",
    content_library: "Libreria dei Contenuti",
    contents: "Contenuti",
    content_categories: "Categorie",
    create_content_category: "Crea Categoria Contenuti",
    edit_content_category: "Modifica Categoria Contenuti",
    create_content: "Crea Contenuto",
    edit_content: "Modifica Contenuto",
    consents: "Consensi",
    consent: "Consenso",
    create_consent: "Crea Consenso",
    edit_consent: "Modifica Consenso",
    consent_version: "Versione Consenso",
    messages: "Messaggi",
    surveys: "Questionari",
    create_survey: "Crea Questionario",
    edit_survey: "Modifica Questionario",
    edit: "Modifica",
    create: "Crea",
    therapy_trend: "Andamento Terapia",
    request_support: "Richiedi Supporto",
    invitation_form: "Form di registrazione",
    zones: "Zone",
    delete_account: "Elimina account",
    policies: "Policy",
    create_edit_zone: "Crea / Modifica Zona",
    privacy_and_cookies: "Privacy e Cookie Policy",
    footer_link: {
      privacy_policy: "Informativa sulla privacy",
      cookie_policy: "Politica sui cookie",
      terms_of_use: "Termini di utilizzo",
    }
  },
  cta: {
    ok: "Ok",
    login: "Accedi ora",
    logout: "Disconnetti",
    submit: "Invia",
    back_to_login: "Torna al login",
    view: "Visualizza",
    view_data: "Visualizza dati",
    hide_data: "Nascondi dati",
    edit: "Modifica",
    search: "Cerca",
    clear_filters: "Cancella filtri",
    delete: "Elimina",
    $delete: {
      title: "Sei sicuro?",
      message: "Questa azione non può essere annullata",
    },
    delete_patient: "Elimina Paziente",
    delete_user: "Elimina Utente",
    delete_center: "Elimina Centro",
    delete_role: "Elimina Ruolo",
    delete_category: "Elimina Categoria",
    delete_content: "Elimina Contenuto",
    delete_consent: "Elimina Consenso",
    delete_event: "Elimina Evento",
    delete_caregiver: "Elimina Caregiver",
    delete_zone: "Elimina Zona",
    confirm: "Conferma",
    continue: "Continua",
    discard: "Annulla",
    stop: "Ferma",
    $discard: {
      message: "Tutti i tuoi progressi andranno persi",
    },
    save: "Salva",
    save_patient: "Salva Paziente",
    save_user: "Salva Utente",
    save_center: "Salva Centro",
    save_role: "Salva Ruolo",
    save_category: "Salva Categoria",
    save_content: "Salva Contenuto",
    save_consent: "Salva Consenso",
    save_consent_version: "Salva Versione",
    save_caregiver: "Salva Caregiver",
    save_zone: "Salva Zona",
    create: "Crea",
    create_patient: "Crea Paziente",
    create_user: "Crea Utente",
    create_center: "Crea Centro",
    create_role: "Crea Nuovo Ruolo",
    create_content_category: "Crea Categoria",
    create_content: "Crea Contenuto",
    create_consent: "Crea Consenso",
    create_consent_version: "Crea Versione",
    restore_consent_version: "Ripristina Versione",
    publish_consent: "Pubblica Versione",
    create_caregiver: "Crea Caregiver",
    create_zone: "Crea Zona",
    schedule_therapy: "Programma Terapia",
    update_password: "Aggiorna password",
    show_all: "Mostra tutto",
    send: "Invia",
    add: "Aggiungi",
    add_event: "Aggiungi Evento",
    edit_event: "Modifica Evento",
    save_event: "Salva Evento",
    add_caregiver: "Aggiungi Caregiver",
    load_more: "Carica altro",
    next: "Avanti",
    recovery_password: "Recupera Password",
    create_survey: "Crea Questionario",
    save_survey: "Salva Questionario",
    delete_survey: "Elimina Questionario",
    invite_user: "Invita Utente",
    accept_invitation: "Accetta Invito",
    download_patient_data: "Scarica dati del paziente",
    withdraw_consent: "Revoca Consenso",
  },
  form: {
    first_name: {
      label: "Nome",
      placeholder: "es. Adam",
    },
    last_name: {
      label: "Cognome",
      placeholder: "es. Rossi",
    },
    gender: {
      label: "Genere",
      0: "Sconosciuto",
      1: "Maschio",
      2: "Femmina",
      3: "Altro",
      4: "Transessuale",
      5: "Sconosciuto",
    },
    birth_date: {
      label: "Data di nascita",
      placeholder: "gg/mm/aaaa",
    },
    email: {
      label: "Email",
      placeholder: "es. adam127704{'@'}gmail.com",
    },
    otp: {
      label: "Codice OTP",
      placeholder: "Inserisci il codice OTP inviato alla tua email",
    },
    password: {
      label: "Password",
      placeholder: "Inserisci la tua password",
    },
    password_confirmation: {
      label: "Conferma password",
      placeholder: "Reinserisci la tua password",
    },
    current_password: {
      label: "Password attuale",
      placeholder: "Inserisci la password attuale",
    },
    address: {
      label: "Indirizzo",
      placeholder: "Aggiungi indirizzo",
    },
    city: {
      label: "Città",
      placeholder: "Aggiungi città",
    },
    region: {
      label: "Regione",
      placeholder: "Aggiungi regione",
    },
    zip_code: {
      label: "CAP",
      placeholder: "Aggiungi CAP",
    },
    country: {
      label: "Paese",
      placeholder: "Aggiungi paese",
    },
    location: {
      label: "Posizione",
      placeholder: "Aggiungi posizione",
    },
    phone: {
      label: "Numero di telefono",
      placeholder: "es. +039 321 4567",
    },
    notes: {
      label: "Note",
      placeholder: "Aggiungi note aggiuntive qui",
    },
    center_id: {
      label: "Centro",
      placeholder: "Seleziona un centro",
    },
    add_caregiver: {
      label: "Aggiungi un caregiver",
    },
    section: {
      patient_information: "Informazioni del paziente",
      user_information: "Informazioni dell'utente",
      anagraph: "Anagrafica",
      credentials: "Credenziali",
      contacts: "Contatti",
      caregiver_information: "Informazioni del caregiver",
      extra: "Extra",
      personal_information: "Informazioni personali",
      department_information: "Informazioni dipartimento",
      location: "Posizione",
    },
    invite_user_instructions:
      "Per attivare il tuo account, completa i campi qui sotto con le informazioni richieste. Al termine riceverai una email con la tua password temporanea per accedere alla piattaforma.",
    created_at: {
      label: "Creato il",
    },
    start_at: {
      label: "Inizio il",
    },
    end_at: {
      label: "Fine il",
      $error: {
        therapy_range_error: "La terapia deve durare almeno {min} giorni",
      },
    },
    name: {
      label: "Nome",
    },
    title: {
      label: "Titolo",
    },
    description: {
      label: "Descrizione",
      placeholder: "Aggiungi una descrizione",
    },
    website: {
      label: "Sito web",
    },
    role: {
      label: "Ruolo",
    },
    role_in_department: {
      label: "Ruolo nel dipartimento",
    },
    organization: {
      label: "Nome dell'organizzazione",
    },
    department: {
      label: "Nome del dipartimento",
    },
    main_contractor: {
      label: "Contatto principale",
    },
    confirmation_code: {
      label: "Codice di conferma",
      placeholder: "Inserisci il codice di conferma ricevuto via email",
    },
    active: {
      label: "Attivo",
    },
    value: {
      label: "Valore",
    },
    subtitle: {
      label: "Sottotitolo",
    },
    url: {
      label: "URL",
    },
    revision_number: {
      label: "Numero di revisione",
      placeholder: "es. 1.2",
    },
    body: {
      label: "Contenuto",
    },
    mandatory: {
      label: "Obbligatorio",
      placeholder:
        "Fornisci il messaggio da mostrare agli utenti che non accettano il consenso obbligatorio",
    },
    has_checkbox: {
      label: "Checkbox di conferma",
      placeholder: "Aggiungi il testo dell’etichetta del checkbox",
    },
    select_placeholder: "Seleziona un'opzione",
    select_file: "Seleziona file",
    subject: {
      label: "Oggetto",
      placeholder: "Inserisci l’oggetto",
    },
    message: {
      label: "Messaggio",
      placeholder: "Inserisci il tuo messaggio",
    },
    type: {
      label: "Tipo",
    },
    date: {
      label: "Data",
    },
    key: {
      label: "Chiave",
    },
    footer: {
      label: "Piè di pagina",
    },
    assignment_strategy: {
      label: "Strategia di assegnazione",
      values: {
        by_hcp: "Da HCP",
        by_center: "Dal Centro",
        self_registration: "Auto-registrazione",
      },
    },
    is_registration_enabled: {
      label: "Abilita l'auto-registrazione dei pazienti",
    }
  },
  error: {
    something_went_wrong: "Qualcosa è andato storto!",
    connection_error:
      "La richiesta non è stata inviata o non è arrivata alcuna risposta dal server.\nVerifica la tua connessione internet.",
  },
  footer_disclaimer: {
    kareena: "",
    sifi_fk: "Tutti i diritti riservati - P.IVA 00122890874",
    fungalk: "Tutti i diritti riservati - P.IVA 00122890874",
  },
  invitation_policies: {
    terms_of_use: 'Ho letto e accetto i <a href="{url}" target="_blank">Termini di utilizzo</a>.',
    privacy_policy: 'I dettagli su come trattiamo i tuoi dati personali sono disponibili nella nostra <a href="{url}" target="_blank">Informativa sulla Privacy</a>.',
    cookie_policy: '<a href="{url}" target="_blank">Informativa sui Cookie</a>.',
  },
  footer_links: {
    terms_of_use: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Terms_of_Use.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Dashboard_Terms_of_Use.pdf",
    },
    privacy_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/Karomy_Platform_Privacy_Notice_Dashboard_Physician.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Platform_Privacy_Notice_Dashboard_Physician.pdf",
    },
    cookie_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Cookie_Policy_EN.pdf',
      fungalk: "",
    },
  },

  "France": 'Francia',
  "Italy": 'Italia',
  "Spain": 'Spagna',
  "United Kingdom": 'Regno Unito',
  "Germany": 'Germania',
};
